// extracted by mini-css-extract-plugin
export var modalFooter = "_ss-0";